import React from 'react';
import { Layout, Menu } from 'antd';
import { HomeOutlined, BookOutlined, FolderOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import logoFull from '../assets/operandi-logo.png';
import logoEmblem from '../assets/operandi-emblem.png';
import { useAppContext } from '../context/AppContext';

const { Sider } = Layout;

const Sidebar = ({ collapsed, onCollapse }) => {
  const { isDarkMode } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();

  const getSelectedKey = (pathname) => {
    if (pathname === '/') return 'home';
    if (pathname.startsWith('/cours')) return 'courses';
    if (pathname.startsWith('/cas')) return 'cases';
    // Legacy routes still mapped (for redirects)
    if (pathname.startsWith('/mes-cours') || pathname.startsWith('/catalogue-cours'))
      return 'courses';
    if (pathname.startsWith('/explorer')) return 'cases';
    return 'home';
  };

  const items = [
    { key: 'home', icon: <HomeOutlined />, label: 'Accueil' },
    { key: 'courses', icon: <BookOutlined />, label: 'Cours' },
    { key: 'cases', icon: <FolderOutlined />, label: 'Cas' },
  ];

  const handleClick = ({ key }) => {
    if (key === 'home') navigate('/');
    else if (key === 'courses') navigate('/cours');
    else if (key === 'cases') navigate('/cas');
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      theme={isDarkMode ? 'dark' : 'light'}
      style={{
        height: '100vh',
        borderRight: `1px solid ${isDarkMode ? '#333333' : '#f0f0f0'}`,
        backgroundColor: isDarkMode ? '#000000' : '#ffffff',
      }}
      trigger={null}
    >
      <div style={{ padding: '16px', textAlign: 'center' }}>
        {collapsed ? (
          <img
            src={logoEmblem}
            alt="OPERANDI"
            style={{ width: '32px', height: '32px' }}
          />
        ) : (
          <img
            src={logoFull}
            alt="OPERANDI"
            style={{ width: '100%', maxWidth: 160, height: 'auto', display: 'block', margin: '0 auto' }}
          />
        )}
      </div>

      <Menu
        theme={isDarkMode ? 'dark' : 'light'}
        mode="inline"
        selectedKeys={[getSelectedKey(location.pathname)]}
        items={items}
        onClick={handleClick}
      />

    </Sider>
  );
};

export default Sidebar;
